/* src/app/private/components/packages/package-form/package-form.component.scss */
:host ::ng-deep .package-tabs .p-tabview-nav {
  background: transparent;
  border-bottom: 1px solid #E2E8F0;
  padding: 0;
}
:host ::ng-deep .package-tabs .p-tabview-nav li {
  margin-right: 0;
}
:host ::ng-deep .package-tabs .p-tabview-nav li .p-tabview-nav-link {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: #64748B;
  padding: 1rem 1.5rem;
  font-weight: 500;
  transition: all 0.2s;
  margin-bottom: -1px;
}
:host ::ng-deep .package-tabs .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus {
  box-shadow: none;
}
:host ::ng-deep .package-tabs .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  border-color: #4F46E5;
  color: #4F46E5;
  background: #F5F7FF;
}
:host ::ng-deep .package-tabs .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link {
  border-color: #E2E8F0;
  color: #1E293B;
}
:host ::ng-deep .package-tabs .p-tabview-panels {
  padding: 0;
  background: transparent;
  border: none;
}
:host ::ng-deep .preview-tabs .p-tabview-nav {
  background: transparent;
  border-bottom: 1px solid #E2E8F0;
  padding: 0;
}
:host ::ng-deep .preview-tabs .p-tabview-nav li {
  margin-right: 0;
}
:host ::ng-deep .preview-tabs .p-tabview-nav li .p-tabview-nav-link {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: #64748B;
  padding: 0.75rem 1rem;
  font-weight: 500;
  transition: all 0.2s;
  margin-bottom: -1px;
  font-size: 0.875rem;
}
:host ::ng-deep .preview-tabs .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus {
  box-shadow: none;
}
:host ::ng-deep .preview-tabs .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  border-color: #4F46E5;
  color: #4F46E5;
  background: #F5F7FF;
}
:host ::ng-deep .preview-tabs .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link {
  border-color: #E2E8F0;
  color: #1E293B;
}
:host ::ng-deep .preview-tabs .p-tabview-panels {
  padding: 0;
  background: transparent;
  border: none;
}
:host ::ng-deep .p-inputgroup .p-inputgroup-addon {
  background: #F8FAFC;
  border-color: #E2E8F0;
  color: #64748B;
  min-width: 2.5rem;
}
:host ::ng-deep .p-inputgroup input,
:host ::ng-deep .p-inputgroup .p-inputnumber-input {
  border-color: #E2E8F0;
}
:host ::ng-deep .p-inputgroup input:focus,
:host ::ng-deep .p-inputgroup .p-inputnumber-input:focus {
  border-color: #4F46E5;
  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.2);
}
:host ::ng-deep .p-dropdown,
:host ::ng-deep .p-inputtext,
:host ::ng-deep .p-inputnumber-input,
:host ::ng-deep .p-inputtextarea {
  border-radius: 0.5rem;
  border-color: #E2E8F0;
  transition: all 0.2s;
}
:host ::ng-deep .p-dropdown:enabled:focus,
:host ::ng-deep .p-inputtext:enabled:focus,
:host ::ng-deep .p-inputnumber-input:enabled:focus,
:host ::ng-deep .p-inputtextarea:enabled:focus {
  border-color: #4F46E5;
  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.1);
}
:host ::ng-deep .p-dropdown:enabled:hover,
:host ::ng-deep .p-inputtext:enabled:hover,
:host ::ng-deep .p-inputnumber-input:enabled:hover,
:host ::ng-deep .p-inputtextarea:enabled:hover {
  border-color: #CBD5E1;
}
:host ::ng-deep .p-button {
  border-radius: 0.5rem;
  transition: transform 0.1s;
}
:host ::ng-deep .p-button:active {
  transform: translateY(1px);
}
:host ::ng-deep .p-button.p-button-secondary {
  background: #FFFFFF;
  border: 1px solid #E2E8F0;
  color: #1E293B;
}
:host ::ng-deep .p-button.p-button-secondary:hover {
  background: #F1F5F9;
}
:host ::ng-deep .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
  background: #10B981;
}
.scrollbar-thin::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.scrollbar-thin::-webkit-scrollbar-track {
  background: #111827;
}
.scrollbar-thin::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 3px;
}
.scrollbar-thin::-webkit-scrollbar-thumb:hover {
  background: #4B5563;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fadein {
  animation: fadeIn 0.3s ease-out forwards;
}
/*# sourceMappingURL=package-form.component.css.map */
